import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type KitTableMessages = ActionButtonMessages &
  PopoverMessages & {
    titleKit: string;
    titleCardKit: string;

    //TABLE COLUMNS
    titleColumn: string;
    quantityColumn: string;
    codeColumn: string;
    mainPriceColumn: string;
    promoPriceColumn: string;
    startPromoPriceColumn: string;
    endPromoPriceColumn: string;
    optionsColumn: string;
    statusColumn: string;

    //Remove Kit Component Dialog
    deleteKitDialogTitle: string;
    deleteKitDialogContent: string;
    deleteKitDialogCancel: string;
    deleteKitDialogConfirm: string;
    deleteKitSuccess: string;
    deleteKitError: string;

    //Update Kit Component Dialog
    updateKitDialogTitle: string;
    quantityLabel: string;
    successUpdateKitMessage: string;
    errorUpdateKitMessage: string;

    //Add SKU
    addSKUButton: string;
    addSKUDialogTitle: string;
    addSKUInputLabel: string;
    addSKUInputPlaceholder: string;
    createKitSuccessMessage: string;
    createKitErrorMessage: string;
    duplicateKitErrorMessage: string;
  };

export const KIT_TABLE_MESSAGES: KitTableMessages = {
  titleKit: "Detalhes do Kit",
  titleCardKit: "Kit",

  //TABLE COLUMNS
  titleColumn: "Nome",
  quantityColumn: "Quantidade",
  codeColumn: "Código",
  mainPriceColumn: "Preço Principal",
  promoPriceColumn: "Preço Promocional",
  startPromoPriceColumn: "Início da Promoção",
  endPromoPriceColumn: "Fim da Promoção",
  statusColumn: "Status",
  optionsColumn: "Opções",

  //Remove Kit Component Dialog
  deleteKitDialogTitle: "Deletar Kit",
  deleteKitDialogContent: "Você tem certeza que deseja deletar este Kit?",
  deleteKitDialogCancel: "Cancelar",
  deleteKitDialogConfirm: "Deletar",
  deleteKitSuccess: "Kit deletado com sucesso!",
  deleteKitError: "Erro ao deletar o kit!",

  //Update Kit Component Dialog
  updateKitDialogTitle: "Salvar Kit",
  quantityLabel: "Quantidade",
  errorUpdateKitMessage: "Erro ao salvar o kit!",
  successUpdateKitMessage: "Kit atualizado com sucesso!",

  //Add SKU
  addSKUButton: "Adicionar SKU",
  addSKUDialogTitle: "Adicionar SKU",
  addSKUInputLabel: "SKU",
  addSKUInputPlaceholder: "Pesquisar por SKU",
  createKitSuccessMessage: "SKU adicionado com sucesso",
  createKitErrorMessage: "Erro ao adicionar SKU no kit",
  duplicateKitErrorMessage: "Este SKU já foi adicionado ao kit",

  ...ACTION_BUTTON_MESSAGES,
  ...POPOVER_MESSAGES,
};
